import { svg, statIcon, rowStat, esc } from '../ui/icons.js';
import { irPara } from '../ui/nav.js';
import { competenciaExtenso } from '../lib/supabase.js';
import {
  dados, estadoEmpresa, progressoEmpresa, empresasDe, empresasVigentes,
  contagemPorEstado, mesDeReferencia,
  STATUS_ITEM_ROTULO, STATUS_ITEM_TAG, ESTADO_EMPRESA,
} from '../state.js';
import { usuario, ehGestao, iniciais } from '../auth.js';
import { abrirFicha } from './ficha.js';

/**
 * Painel do colaborador e painel da gestão.
 *
 * Mudança em relação ao protótipo: o "quem sou eu" não vem mais de um
 * <select>, vem da sessão. Colaborador nem vê o botão de trocar para a
 * visão de gestão — e, se forçasse, a RLS não devolveria nada a mais.
 */

let visao = 'colaborador';

export function montarChrome({ aoTrocarVisao }) {
  const toggle = document.getElementById('roleToggle');

  if (!ehGestao()) {
    toggle.style.display = 'none';
    visao = 'colaborador';
  } else {
    toggle.style.display = '';
    toggle.querySelectorAll('button').forEach((b) =>
      b.addEventListener('click', () => {
        visao = b.dataset.role;
        toggle.querySelectorAll('button').forEach((x) => x.classList.toggle('active', x === b));
        document.getElementById('view-colaborador').style.display =
          visao === 'colaborador' ? '' : 'none';
        document.getElementById('view-gestao').style.display =
          visao === 'gestao' ? '' : 'none';
        aoTrocarVisao?.();
        render();
      })
    );
  }

  document.getElementById('view-gestao').style.display = 'none';
}

export function render() {
  const u = usuario();
  document.getElementById('dashDate').innerHTML =
    `${svg('calendar', 14)} ${new Date().toLocaleDateString('pt-BR')}`;

  if (visao === 'colaborador') {
    document.getElementById('dashTitle').textContent = 'Painel do colaborador';
    document.getElementById('dashSub').textContent =
      'Clique em qualquer número para ver quais empresas estão nele.';
    document.getElementById('dashAvatar').textContent = iniciais(u.nome);
    document.getElementById('dashWho').textContent = u.nome;
    // Só a gestão mostra papel. O "Analista Contábil" que aparecia para o
    // colaborador era invenção da migração do protótipo — ninguém nunca
    // disse qual é o cargo dessas pessoas, e o sistema não tem por que
    // afirmar um.
    mostrarPapel(ehGestao() ? 'Gestão · Contábil' : null);
    renderColaborador();
  } else {
    document.getElementById('dashTitle').textContent = 'Painel da gestão';
    document.getElementById('dashSub').textContent =
      'Indicadores do setor e carga de trabalho por colaborador.';
    document.getElementById('dashAvatar').textContent = iniciais(u.nome);
    document.getElementById('dashWho').textContent = u.nome;
    mostrarPapel('Gestão · Contábil');
    renderGestao();
  }
}

/** Sem papel, a linha some — não fica um espaço vazio embaixo do nome. */
function mostrarPapel(texto) {
  const el = document.getElementById('dashRole');
  el.textContent = texto || '';
  el.hidden = !texto;
}

/* ------------------------------------------------------------------ */
/* Visão do colaborador                                                */
/* ------------------------------------------------------------------ */

function renderColaborador() {
  const u = usuario();
  const minhas = empresasDe(u.id);
  const minhasTarefas = dados.tarefas.filter((t) => t.responsavel?.id === u.id);

  const porStatus = (s) => minhas.filter((e) => estadoEmpresa(e) === s).length;

  document.getElementById('statGrid').innerHTML = `
    <div class="stat-card" data-ir="empresas">${statIcon('purple', 'building')}<p class="label">MINHAS EMPRESAS</p><p class="num">${minhas.length}</p>
      <div class="stat-row">${rowStat('green', porStatus('andamento'), 'Em andamento')}${rowStat('amber', porStatus('a_realizar'), 'A realizar')}${rowStat('purple', porStatus('concluido'), 'Concluídas')}</div></div>
    <div class="stat-card" data-ir="documentos">${statIcon('blue', 'doc')}<p class="label">DOCUMENTOS</p><p class="num">${contagemDoc(minhas).total}</p>
      <div class="stat-row">${rowStat('red', contagemDoc(minhas).faltantes, 'Faltantes')}${rowStat('green', contagemDoc(minhas).recebidos, 'Recebidos')}</div></div>
    <div class="stat-card" data-ir="tarefas">${statIcon('green', 'check')}<p class="label">MINHAS TAREFAS</p><p class="num">${minhasTarefas.length}</p>
      <div class="stat-row">${rowStat('amber', minhasTarefas.filter((t) => t.status === 'Em andamento').length, 'Em andamento')}${rowStat('green', minhasTarefas.filter((t) => t.status === 'Concluído').length, 'Concluídas')}</div></div>
    <div class="stat-card" data-ir="empresas" data-status="a_realizar">${statIcon('amber', 'bars')}<p class="label">FECHAMENTOS ABERTOS</p><p class="num">${minhas.filter((e) => e.competencia_aberta).length}</p>
      <div class="stat-row">${rowStat("amber", minhas.filter((e) => estadoEmpresa(e) === "a_realizar").length, "empresas a realizar")}</div></div>
    <div class="stat-card">${statIcon('purple', 'edit')}<p class="label">REALIZADO DO DIA</p><p class="num" id="dashRealizado">${meuRealizado().length}</p>
      <div class="stat-row"><div class="r"><span>atividades hoje</span></div></div>
      <button class="btn primary" style="width:100%;margin-top:10px;" id="btnVerRealizado">Ver detalhes</button></div>
  `;
  document.getElementById('btnVerRealizado').addEventListener('click', () => irPara('realizado'));
  ligarCartoes(document.getElementById('statGrid'));

  /*
   * Precisa de atenção = duas origens, na mesma lista.
   *
   *  1. O que a própria pessoa travou: item marcado como Em andamento, ou
   *     com observação explicando o impedimento.
   *  2. O que a gestão apontou na revisão: comentário ainda não resolvido.
   *
   * A segunda origem faltava, e era a mais importante das duas: correção
   * apontada que o colaborador não vê é correção que não acontece. Ficava
   * só dentro da ficha do item, onde ninguém passa sem motivo.
   */
  const idsMinhas = new Set(minhas.map((e) => e.id));

  const travados = dados.sinalizados
    .filter((s) => idsMinhas.has(s.fechamento?.empresa?.id))
    .map((a) => ({
      empresaId: a.fechamento.empresa.id,
      empresa: a.fechamento.empresa.nome,
      desc: a.nome + (a.obs ? ' — ' + a.obs : ''),
      tag: STATUS_ITEM_TAG[a.status],
      rotulo: STATUS_ITEM_ROTULO[a.status],
    }));

  const TIPO_COMENTARIO = {
    correcao:   ['red', 'Correção'],
    orientacao: ['amber', 'Orientação'],
    duvida:     ['blue', 'Dúvida'],
  };

  const comentados = dados.comentariosAbertos
    .filter((c) => idsMinhas.has(c.empresa_id))
    .map((c) => {
      const [tag, rotulo] = TIPO_COMENTARIO[c.tipo] || ['amber', c.tipo];
      return {
        empresaId: c.empresa_id,
        empresa: c.empresa_nome,
        desc: `${c.item_nome} — ${c.texto}${c.autor_nome ? ' (' + c.autor_nome + ')' : ''}`,
        tag, rotulo,
      };
    });

  // Correção primeiro: é o que alguém está esperando.
  const meus = [...comentados, ...travados];

  const cabecalhos = document.querySelectorAll('#view-colaborador .section-head');
  cabecalhos[0].innerHTML =
    `<h2 style="color:var(--red-text);">${svg('alert', 17)} Precisa de atenção</h2>` +
    `<span class="count" style="color:var(--purple-text);font-weight:600;">${meus.length} itens</span>`;

  document.getElementById('attnList').innerHTML = meus.length
    ? meus.map((a) => `
        <div class="attn-row" data-emp="${a.empresaId}">
          <div class="attn-main">
            <p class="name">${esc(a.empresa)}</p>
            <p class="desc">${esc(a.desc)}</p>
          </div>
          <span class="tag ${a.tag}">${esc(a.rotulo)}</span>
        </div>`).join('')
    : `<p style="font-size:13px;color:var(--text-muted);margin:6px 0;">
         Nada travado nem apontado nas suas empresas.</p>`;

  document.getElementById('attnList').querySelectorAll('.attn-row')
    .forEach((r) => r.addEventListener('click', () => abrirFicha(r.dataset.emp)));

  // Em andamento
  cabecalhos[1].innerHTML =
    `<h2 style="color:var(--green-text);">${svg('check', 17)} Em andamento</h2>` +
    `<span class="count" id="verTodasEmpresas" style="color:var(--purple-text);font-weight:600;cursor:pointer;">Ver todas ${svg('arrow', 13)}</span>`;
  document.getElementById('verTodasEmpresas').addEventListener('click', () => irPara('empresas'));

  const emAndamento = minhas.filter((e) => estadoEmpresa(e) === 'andamento');
  document.getElementById('progressList').innerHTML = emAndamento.length
    ? emAndamento.map((e) => `
        <div class="progress-row">
          <div class="progress-top"><span class="pname">${esc(e.nome)}</span><span class="tag amber">Em andamento</span></div>
          <div class="progress-track"><div class="progress-fill" style="width:${progressoEmpresa(e)}%;"></div></div>
        </div>`).join('')
    : `<p style="font-size:13px;color:var(--text-muted);margin:6px 0;">Nenhuma empresa sua em andamento agora.</p>`;

  renderAtalhos();
  renderLogDoDia();
}

/**
 * Documentos do mês de referência, contando documento de verdade.
 *
 * A versão anterior não olhava a tabela de documentos: contava contas
 * bancárias menos itens de conferência pendentes, e por isso mostrava
 * "0 faltantes, 13 recebidos" quando não existia um único documento
 * registrado. Um botão morto a pessoa percebe; um número errado ela
 * acredita.
 */
/**
 * Faz o número levar a algum lugar.
 *
 * O subtítulo do painel dizia "clique nos detalhes" e nada era clicável.
 * Saber que há 40 empresas a realizar não ajuda ninguém; ver quais são,
 * ajuda.
 *
 * O cartão carrega no `data-status` o filtro que a tela de destino deve
 * aplicar, para o clique chegar já filtrado em vez de despejar a lista
 * inteira.
 */
function ligarCartoes(container) {
  if (!container) return;
  container.querySelectorAll('[data-ir]').forEach((cartao) =>
    cartao.addEventListener('click', () => {
      const destino = cartao.dataset.ir;
      const status = cartao.dataset.status || '';

      if (destino === 'empresas') {
        const filtro = document.getElementById('empFilterStatus');
        if (filtro) filtro.value = status;
        // A lista de empresas mostra só quem gera trabalho por padrão,
        // que é exatamente o universo que o cartão contou.
        const tipo = document.getElementById('empFilterTipo');
        if (tipo) tipo.value = '';
        irPara('empresas');
        filtro?.dispatchEvent(new Event('change'));
        return;
      }

      irPara(destino);
    })
  );
}

function contagemDoc(empresas) {
  let total = 0;
  let recebidos = 0;
  for (const e of empresas) {
    for (const b of e.bancos || []) {
      total++;
      if (dados.docsRecebidos.has(b.id)) recebidos++;
    }
  }
  return { total, recebidos, faltantes: total - recebidos };
}

function meuRealizado() {
  const u = usuario();
  return dados.realizado.filter((l) => l.colaborador?.id === u.id);
}

/*
 * Atalhos.
 *
 * Empresas, Documentos e Tarefas saíram: os cartões lá de cima agora
 * levam às mesmas telas, e repetir o mesmo destino duas vezes na mesma
 * página só ocupa espaço.
 *
 * Ficam o que não tem cartão: Pesquisas e Base de conhecimento. O
 * Balancete continua fora enquanto depender da importação do Domínio.
 */
function renderAtalhos() {
  const atalhos = [
    { id: 'pesquisas', icon: 'search', cor: 'purple', t: 'Pesquisas', d: 'O que a equipe já pesquisou, para não pesquisar de novo' },
    { id: 'conhecimento', icon: 'book', cor: 'blue', t: 'Base de conhecimento', d: 'Os manuais e procedimentos internos, com busca no texto' },
  ];
  const grid = document.getElementById('shortcutGrid');
  grid.innerHTML = atalhos.map((s) => `
    <div class="shortcut-card row-click" data-page="${s.id}">
      <span class="arrow">${svg('arrow', 15)}</span>${statIcon(s.cor, s.icon)}
      <p class="t">${s.t}</p><p class="d">${s.d}</p>
    </div>`).join('');
  grid.querySelectorAll('.shortcut-card')
    .forEach((c) => c.addEventListener('click', () => irPara(c.dataset.page)));
}

function renderLogDoDia() {
  document.getElementById('dashLogHead').innerHTML =
    `<h2>${svg('calendar', 17)} Realizado do dia</h2>` +
    `<button class="btn primary" id="btnNovaAtividade">${svg('plus', 14)} Nova atividade</button>`;
  document.getElementById('btnNovaAtividade').addEventListener('click', () => irPara('realizado'));
  document.getElementById('resumoHead').innerHTML = `<h2>${svg('bars', 17)} Resumo do dia</h2>`;
  document.getElementById('verRelatorioDia').onclick = () => irPara('realizado');

  const linhas = meuRealizado().slice(0, 6);
  document.querySelector('#dashLogTable tbody').innerHTML = linhas.length
    ? linhas.map((l) => {
        const tag = l.status === 'Concluído' ? 'green' : 'amber';
        return `<tr><td>${l.hora?.slice(0, 5) ?? ''}</td><td>${esc(l.empresa?.nome || l.empresa_texto || '—')}</td><td>${esc(l.atividade)}</td><td><span class="tag ${tag}">${l.status}</span></td></tr>`;
      }).join('')
    : `<tr><td colspan="4" style="color:var(--text-muted);">Nenhum registro ainda hoje.</td></tr>`;

  const empresasHoje = new Set(
    meuRealizado().map((l) => l.empresa?.id || l.empresa_texto)
  ).size;

  const itens = [
    { icon: 'check', cor: 'green', num: meuRealizado().length, rotulo: 'Atividades realizadas' },
    { icon: 'building', cor: 'purple', num: empresasHoje, rotulo: 'Empresas trabalhadas' },
    { icon: 'doc', cor: 'blue', num: dados.sinalizados.filter((s) => s.status !== 'ok').length, rotulo: 'Itens sinalizados' },
    { icon: 'search', cor: 'purple', num: dados.pesquisas.length, rotulo: 'Pesquisas registradas' },
  ];
  document.getElementById('resumoList').innerHTML = itens.map((i) => `
    <div class="resumo-row">
      <div class="ric stat-icon ${i.cor}" style="margin-bottom:0;">${svg(i.icon, 14)}</div>
      <span class="rnum">${i.num}</span><span class="rlabel">${i.rotulo}</span>
    </div>`).join('');
}

/* ------------------------------------------------------------------ */
/* Visão da gestão                                                     */
/* ------------------------------------------------------------------ */

function renderGestao() {
  // Ex-cliente fora de todos os indicadores: contá-lo distorce o painel.
  const vigentes = empresasVigentes();
  /*
   * A contagem é POR EMPRESA, nunca por item nem por mês.
   *
   * O painel antigo somava os itens de conferência de todas as
   * competências: dava "6.671 pendências críticas", que era o número de
   * casinhas em branco do ano inteiro. Cada empresa agora está num estado
   * só, e os três somam o total.
   */
  const conta = contagemPorEstado(vigentes);
  const referencia = competenciaExtenso(mesDeReferencia());

  const tarefasAbertas = dados.tarefas.filter((t) => t.status !== 'Concluído').length;
  const altaPrioridade = dados.tarefas.filter((t) => t.prioridade === 'Alta' && t.status !== 'Concluído').length;

  const comFechamento = vigentes.filter((e) => e.competencia_aberta);
  const mediaChecklist = comFechamento.length
    ? Math.round(comFechamento.reduce((s, e) => s + progressoEmpresa(e), 0) / comFechamento.length)
    : 100;

  document.getElementById('kpiGrid').innerHTML = `
    <div class="kpi-card acionavel" data-ir="empresas" data-status="concluido">
      <p class="label">CONCLUÍDO</p><p class="num" style="color:var(--green-text);">${conta.concluido}<small> / ${conta.total}</small></p>
      <p class="sub">em dia até ${referencia}</p></div>
    <div class="kpi-card acionavel" data-ir="empresas" data-status="andamento">
      <p class="label">EM ANDAMENTO</p><p class="num" style="color:var(--amber-text);">${conta.andamento}</p>
      <p class="sub">começaram e não fecharam</p></div>
    <div class="kpi-card acionavel" data-ir="empresas" data-status="a_realizar">
      <p class="label">A REALIZAR</p><p class="num" style="color:var(--red-text);">${conta.a_realizar}</p>
      <p class="sub down">nenhum mês feito ainda</p></div>
    <div class="kpi-card acionavel" data-ir="tarefas">
      <p class="label">TAREFAS EM ABERTO</p><p class="num">${tarefasAbertas}<small> / ${dados.tarefas.length}</small></p>
      <p class="sub">${altaPrioridade} de prioridade alta</p></div>
    <div class="kpi-card"><p class="label">FECHAMENTO MÉDIO</p><p class="num">${mediaChecklist}%</p><p class="sub ${mediaChecklist >= 70 ? 'up' : 'down'}">média do checklist de ${dados.checklistTotal} itens</p></div>
  `;
  ligarCartoes(document.getElementById('kpiGrid'));

  // Carga por colaborador — também por empresa, não por item. Somar itens
  // dava "1.976 pendências" para o Ademir, que era o número de casinhas em
  // branco do ano, não a carga dele.
  document.getElementById('loadList').innerHTML = dados.colaboradores.map((c) => {
    const minhas = vigentes.filter((e) => (e.responsaveis || []).some((r) => r.id === c.id));
    const pend = minhas.filter((e) => estadoEmpresa(e) === 'a_realizar').length;
    const abertas = dados.tarefas.filter((t) => t.responsavel?.id === c.id && t.status !== 'Concluído').length;
    const pct = minhas.length ? Math.round((pend / minhas.length) * 100) : 0;
    const cor = pct >= 60 ? 'red' : (pct >= 25 ? 'amber' : 'green');
    return `
      <div class="load-row">
        <div class="load-top">
          <span class="lname"><span class="load-avatar">${iniciais(c.nome)}</span>${esc(c.nome)}</span>
          <span class="tag ${cor}">${pend} a realizar</span>
        </div>
        <div class="progress-track"><div class="progress-fill" style="width:${pct}%;background:var(--${cor});"></div></div>
        <p style="font-size:11.5px;color:var(--text-muted);margin:6px 0 0;">${minhas.length} empresas · ${abertas} tarefas em aberto</p>
      </div>`;
  }).join('');

  // Alertas
  const atrasadas = vigentes.filter((e) => e.competencia_aberta && progressoEmpresa(e) < 90).length;
  const sobrecarregados = dados.colaboradores.filter((c) =>
    vigentes
      .filter((e) => (e.responsaveis || []).some((r) => r.id === c.id))
      .reduce((n, e) => n + e.pendencias, 0) >= 3
  );

  const alertas = [
    ...(dados.sinalizados.length
      ? [{ icon: 'alert', cor: 'red', txt: `${dados.sinalizados.length} itens de conferência com observações precisando da sua revisão` }]
      : []),
    ...sobrecarregados.map((c) => ({
      icon: 'alert', cor: 'red',
      txt: `${esc(c.nome)} está com pendências acumuladas em várias empresas`,
    })),
    { icon: 'doc', cor: 'amber', txt: `${atrasadas} empresas sem o fechamento concluído` },
    { icon: 'check', cor: 'purple', txt: `${altaPrioridade} tarefas de prioridade alta em aberto` },
  ];

  document.getElementById('gestaoAlertHead').innerHTML =
    `<h2 style="color:var(--red-text);">${svg('alert', 17)} Alertas do setor</h2>`;
  document.getElementById('gestaoAlertList').innerHTML = alertas.map((a) => `
    <div class="attn-row" style="cursor:default;">
      <div class="stat-icon ${a.cor}" style="width:30px;height:30px;margin-bottom:0;">${svg(a.icon, 14)}</div>
      <div class="attn-main"><p class="desc" style="font-size:13px;color:var(--text-primary);">${a.txt}</p></div>
    </div>`).join('');

  // Tabela de empresas — as que mais precisam de atenção primeiro.
  // Com 170 clientes, listar tudo em ordem alfabética não ajuda ninguém:
  // o que a gestão quer ver é onde está o problema.
  const LIMITE_PAINEL = 25;
  const ordenadas = [...vigentes].sort((a, b) =>
    b.pendencias - a.pendencias || progressoEmpresa(a) - progressoEmpresa(b)
  );
  const doPainel = ordenadas.slice(0, LIMITE_PAINEL);

  document.getElementById('empGestaoCount').textContent =
    conta.total > LIMITE_PAINEL ? `${LIMITE_PAINEL} que mais precisam de atenção, de ${conta.total}` : `${conta.total} empresas`;
  document.querySelector('#gestaoEmpTable tbody').innerHTML = doPainel.map((e) => {
    const [tag, rotulo] = ESTADO_EMPRESA[estadoEmpresa(e)];
    return `<tr class="row-click" data-emp="${e.id}">
      <td><b>${esc(e.nome)}</b></td>
      <td>${esc((e.responsaveis || []).map((r) => r.nome).join(', ') || '—')}</td>
      <td><span class="tag ${tag}">${rotulo}</span></td>
      <td style="display:flex;align-items:center;gap:8px;">
        <div class="progress-track" style="width:70px;"><div class="progress-fill" style="width:${progressoEmpresa(e)}%;"></div></div>
        <span style="font-size:12px;color:var(--text-secondary);">${progressoEmpresa(e)}%</span>
      </td></tr>`;
  }).join('');

  document.querySelectorAll('#gestaoEmpTable tbody tr')
    .forEach((r) => r.addEventListener('click', () => abrirFicha(r.dataset.emp)));
}

